(function () {
    'use strict';

    HelpTextCtrl.$inject = ['$scope', '$sce'];

    angular
        .module('app')
        .directive('drvHelpText', drvHelpText);

    /**
     * @ngdoc directive
     * @name drvHelpText
     *
     * @description
     * For displaying a small 'info' icon that can be clicked on to display help text in a popup / tooltip.
     */
    function drvHelpText() {
        return {
            templateUrl: 'app/help-text.tmpl.html',
            scope: {
            },
            controller: HelpTextCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                condensed: '<?'
            }
        };
    }

    function HelpTextCtrl($scope, $sce) {
        var drvCtrl = this;
        Object.defineProperty(drvCtrl, 'showHelpText', {
            get: function () { return !angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value !== ''; }
        });

        // Use a watch instead of a getter property, because that can lead to an infinite digest loop.
        // http://stackoverflow.com/questions/19369406/ng-bind-html-gives-an-infinite-digest-error-rootscope-infdig
        $scope.$watch('drvCtrl.value', function (val) {
            drvCtrl.trustedHtml = $sce.trustAsHtml(val);
        });
    }
})();